import { message } from 'antd';

const alertMessage = (text: string, icon?: React.ReactNode) => {
  return message.success({
    icon: <></>,
    content: (
      <>
        {icon && icon} {text}
      </>
    ),
    style: { marginTop: '50px' }
  });
};
export default alertMessage;
